module.exports = {
  port: process.env.VOLTRAN_PORT || 4000,
  baseUrl: 'https://loyalty-voltran.hepsiburada.com',
  loginUrl: 'https://uyelik.hepsiburada.com/uyelik/giris?returnURL=',
  legendsClubUrl: 'http://efsanelerkulubu.hepsiburada.com',
  environment: 'production',
  mediaUrl: 'https://loyalty-voltran.hepsiburada.com',
  corsWhiteListDomains: [/^(.*\.)?hepsiburada\.com?(.*)/],
  logLevel: 'info',
  isCssClassNameObfuscationEnabled: false,
  voltranCommonUrl: 'https://voltrancommon.hepsiburada.com/common.js',
  loyaltyServiceUrl: 'https://loyalty-agw.hepsiburada.com',
  loyaltyBoServiceUrl: 'https://loyalty-bo-agw.hepsiburada.com',
  loyaltyUrl: 'https://premium.hepsiburada.com',
  loyaltyBoUrl: 'https://loyalty-bo.hepsiburada.com',
  loyaltyAccountManagementUrl: 'https://premium.hepsiburada.com/uyeligi-yonet',
  previewHBusVersion: '3.3.38',
  services: {},
  newrelicEnabled: true,
  hbusEnabled: true,
  savedCardUrl: 'https://www.hepsiburada.com/hesabim/kayitli-kartlarim',
  mobileApiUrl: 'https://www.hepsiburada.com/api/v1',
  paymentVoltranUrl: 'https://payment-mfe.hepsiburada.com',
  voltranEnv: 'production',
  redirectBasketUrl: 'https://www.hepsiburada.com/premium?basket=true',
  homeUrl: 'https://www.hepsiburada.com/',
  savedCardUrlDeepLink:
    'hbapp://staticpage?staticPageId=9697&url=https%3A%2F%2Fwww.hepsiburada.com%2Fhesabim%2Fkayitli-kartlarim&loginRequired=true',
  bluTvCampaignUrl: '62b00053e745c64fa3a5bcd1'
};
